import React from 'react'

function Websitepolicy() {
    return (
 <div>
      <div class="heading"><h2>Website Policy</h2></div>
        <div class="content-container">
        
    
        <div>
          
        <div class="policycontent-container">
        
    <div className='policycontent'>
    <p className='' style={{fontWeight:600}}>Accessibility Statement</p>
        <p>We are committed to ensure that the NIGST website is accessible to all users irrespective of device in use,
          technology, or ability. It has been built, with an aim, to provide maximum accessibility and usability to its
          visitors. As a result, this website can be viewed from a variety of devices such as Desktop / Laptop
          computers, web-enabled mobile devices; wap phones; PDAs, etc.
          We have put in our best efforts to ensure that all information on this website is accessible to people with
          disabilities. For example, a user with a visual disability can access this website using assistive
          technologies, such as screen readers and screen magnifiers. We also aim to be standards compliant and follow
          principles of usability and universal design, which should help all visitors of this website.
          This website is designed using HTML 4.01 Transitional to meet Guidelines for Indian Government Websites and
          also adheres to Level AA of the Web Content Accessibility Guidelines (WCAG) 2.0 laid down by the World Wide
          Web Consortium (W3C). Part of the information on the website is also made available through links to external
          Websites. External Websites are maintained by the respective departments who are responsible for making these
          sites accessible.
        </p>
        <p style={{fontWeight:600}}>Accessibility Options</p>
        <p>
        <ul>
          <li> You can change the text size larger, smaller or back to standard </li>
          <li>You may customize this site for a better reading experience.</li>
          <li>You will also know what percentage of zoom you are currently on</li>
          <li>For your convenience, your preferences will remain for any page you visit on this site until you change it
            by simply going back to this page, setting the page style back to standard and then clicking the Text Size
            in the header.</li>
          <li>The text size changes are in increments of 10% to a maximum of 200% and minimum of 50%.</li>
          <li>Also, you will notice in your browser, no matter which one you use, you will have additional options in
            your toolbar view menu for the page style background and text color combinations. So you have a choice of
            choosing your preferences from this accessibility page or from your own browser toolbar menu under view.
            Your hot keys may depend on what browser you are using. For example, if you are using Mozilla Firefox or
            Internet Explorer you may go to Alt + V (for view) and type the letter "Y" for Page Style. You will see the
            four background and text color combinations available for you to choose. You will also see "No Style". That
            always was an option in your browser and when you choose this, it strips all style and graphics, leaving
            only text and links. That is nothing additional that we added. So if you have experimented with color
            combinations and want to get back to the standard style of this site, do not choose "No style" from your
            browser. Choose "standard" either from your browser or this page.</li>


        </ul>
        </p>
        </div>
      </div>
      </div>
    </div>
    </div>

     
    )
}

export default Websitepolicy